import { Box, Heading, Text, SimpleGrid, Flex, Button, Badge } from '@chakra-ui/react'
import { FileText, Download, Eye } from 'lucide-react'
import { useAccountingContext } from '../../context/AccountingContext'

const reports = [
  {
    id: 'annexe1',
    name: 'Annexe 1 - État financier',
    description: 'Situation générale de la copropriété',
    category: 'annexes_ag',
  },
  {
    id: 'annexe2',
    name: 'Annexe 2 - Compte de gestion général',
    description: 'Charges et produits de l\'exercice',
    category: 'annexes_ag',
  },
  {
    id: 'annexe3',
    name: 'Annexe 3 - Compte de gestion travaux',
    description: 'Travaux et opérations exceptionnelles',
    category: 'annexes_ag',
  },
  {
    id: 'annexe4',
    name: 'Annexe 4 - État des dettes fournisseurs',
    description: 'Détail des sommes dues aux fournisseurs',
    category: 'annexes_ag',
  },
  {
    id: 'balance',
    name: 'Balance générale',
    description: 'Balance des comptes',
    category: 'comptable',
  },
  {
    id: 'grand_livre',
    name: 'Grand livre',
    description: 'Détail de toutes les écritures par compte',
    category: 'comptable',
  },
  {
    id: 'journal',
    name: 'Journal centralisateur',
    description: 'Toutes les écritures par ordre chronologique',
    category: 'comptable',
  },
  {
    id: 'compte_copro',
    name: 'Relevé individuel copropriétaire',
    description: 'Extrait de compte pour un copropriétaire',
    category: 'copropriétaires',
  },
]

export function ReportsTab() {
  const { residenceId: _residenceId, activeFiscalYear: _activeFiscalYear } = useAccountingContext()
  // LOT 2 - fiscalYearId sera utilisé plus tard
  const categories = {
    annexes_ag: 'Annexes AG (obligatoires)',
    comptable: 'États comptables',
    copropriétaires: 'Documents copropriétaires',
  }

  const handleGenerate = (reportId: string) => {
    // TODO: Implement PDF generation
    console.log('Generating report:', reportId)
  }

  const handlePreview = (reportId: string) => {
    // TODO: Implement preview
    console.log('Preview report:', reportId)
  }

  return (
    <Box>
      {Object.entries(categories).map(([categoryKey, categoryLabel]) => (
        <Box key={categoryKey} mb={6}>
          <Heading size="md" mb={4}>
            {categoryLabel}
          </Heading>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={4}>
            {reports
              .filter((r) => r.category === categoryKey)
              .map((report) => (
                <Box
                  key={report.id}
                  p={4}
                  bg="white"
                  borderRadius="lg"
                  boxShadow="sm"
                  border="1px solid"
                  borderColor="gray.100"
                  _hover={{ borderColor: 'brand.200', boxShadow: 'md' }}
                  transition="all 0.2s"
                >
                  <Flex justify="space-between" align="start" mb={2}>
                    <Box color="brand.500">
                      <FileText size={24} />
                    </Box>
                    {categoryKey === 'annexes_ag' && (
                      <Badge colorPalette="blue" variant="subtle">
                        Obligatoire
                      </Badge>
                    )}
                  </Flex>

                  <Heading size="sm" mb={1}>
                    {report.name}
                  </Heading>
                  <Text fontSize="sm" color="gray.600" mb={4}>
                    {report.description}
                  </Text>

                  <Flex gap={2}>
                    <Button
                      size="sm"
                      variant="outline"
                      flex={1}
                      onClick={() => handlePreview(report.id)}
                    >
                      <Eye size={14} />
                      Aperçu
                    </Button>
                    <Button
                      size="sm"
                      colorPalette="brand"
                      flex={1}
                      onClick={() => handleGenerate(report.id)}
                    >
                      <Download size={14} />
                      PDF
                    </Button>
                  </Flex>
                </Box>
              ))}
          </SimpleGrid>
        </Box>
      ))}
    </Box>
  )
}
